<template>
  <div>
    <div class="select_items">
      <div class="flex_select">
        <div class="select_item">
          <select
            id="history"
            v-model="select_history_time"
            name="history"
            class="amount-input selectpix"
            @change="selectHistoryimeChange"
          >
            <option
              value="1"
              :selected="select_history_time == '1'"
            >
              {{ $t("今天") }}
            </option>
            <option
              value="2"
              :selected="select_history_time == '2'"
            >
              {{ $t("昨天") }}
            </option>
            <option
              value="3"
              :selected="select_history_time == '3'"
            >
              {{ $t("过去7天") }}
            </option>
            <option
              value="4"
              :selected="select_history_time == '4'"
            >
              {{ $t("过去15天") }}
            </option>
            <option
              value="5"
              :selected="select_history_time == '5'"
            >
              {{ $t("过去30天") }}
            </option>
          </select>
        </div>
        <!-- <div class="select_item">
          <select
            id="type"
            name="type"
            class="amount-input selectpix"
            v-model="select_history_type"
            @change="selectHistoryTypeChange"
          >
            <option value="all" :selected="select_history_type == 'all'">
              Todos
            </option>
            <option value="0" :selected="select_history_type == '0'">
              Resgatado
            </option>
            <option value="1" :selected="select_history_type == '1'">
              Distribuído
            </option>
          </select>
        </div> -->
      </div>

      <div class="bonus">
        {{ $t("奖金") }}: <span>{{ history.bonus }}</span>
      </div>
    </div>
    <div class="history_content">
      <div
        v-for="item in history.list"
        :key="item.id"
        class="history_items"
      >
        <div class="title">
          <div class="name">
            {{ item.memo }}
          </div>
          <div class="content">
            <span class="currency">R$</span><span class="money">{{ item.money }}</span><span class="time">{{
              item.createtime }}</span><span class="label">{{ $t("来源") }}:</span><span class="value">{{ item.memo
            }}</span>
          </div>
        </div>
        <div class="history-item-right">
          <div class="btn is-collected">
            {{ $t("获救") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Fetch from "../../utils/fetch";
export default {
  name: "History",
  components: {},
  data() {
    return {
      select_history_time: "1",
      select_history_type: "all",
      history: {
        bonus: "0.00",
        list: [],
      },
    };
  },
  created() { },
  beforeDestroy() { },
  mounted() {
    this.getHistoryList();
  },
  methods: {
    selectHistoryimeChange() {
      this.getHistoryList();
    },
    selectHistoryTypeChange() { },
    getHistoryList() {
                // this.history.list = [{memo:"123123123",money:"124534546545",createtime:"9999999999999"}]
      Fetch("/record/moneyLog", {
        timeType: this.select_history_time,
      }).then((r) => {
        if (r.data) {
          this.history.bonus = r.data.bonus;
          this.history.list = r.data.list;
          // this.history.list = [{memo:"123123123",money:"124534546545",createtime:"99999999"}]
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/variables.less";

select {
  border-radius: 0.5rem;
  color: #fff;
  background-color: @secondary-color;
}

.select_items {
  display: flex;
  justify-content: space-between;
  padding-top: 0.2rem;
  padding-bottom: 0.4rem;
}

select {
  height: 0.7rem;
  border: 0.01rem solid @bodercolor;
  padding-left: 0.4rem;
  margin-left: 0.3rem;
  font-size: 0.26rem;
  color: @popupTextColor;
}

.flex_select {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.bonus {
  color: @popupTextColor;
  margin-right: 0.3rem;
  font-size: 0.35rem;
  margin-top: 0.13rem;

  span {
    color: @rechargeColor !important;
  }
}

.history_content {
  padding: 0.3rem;
  padding-bottom: 2rem;

  .history_items {
    background-color: @secondary-color;
    height: 2rem;
    border-radius: 0.2rem;
    display: flex;
    padding: 0.2rem;
    margin-bottom: 0.3rem;

    .title {
      width: 80%;

      .name {
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        display: -webkit-box;
        font-size: 0.3rem;
        height: 1.5rem;
        line-height: 0.9rem;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #fff;
      }

      .content {
        display: flex;
        align-items: center;
        font-size: 0.26rem;

        .currency {
          height: 0.3rem;
          margin-right: 0.04rem;
          line-height: 0.3rem;
          font-size: 0.3rem;
          border-radius: 0.2rem;
          background-color: @rechargeColor;
          color: @activityColor;
        }

        .money {
          color: @rechargeColor;
          margin-right: 0.3rem;
        }

        .time {
          color: @popupTextColor;
          margin-right: 0.3rem;
        }

        .label {
          color: @popupTextColor;
        }

        .value {
          padding-left: 0.06rem;
          color: @rechargeColor;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }

    .history-item-right {
      width: 20%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 0.26rem;
      color: #04be02;
    }
  }
}
</style>